module.exports = {"title":"蘑菇社区","meta":{"title":"蘑菇社区 - 一个专注于技术分享的博客平台","description":"一个专注于技术分享的社区平台，大家以共同学习，乐于分享，拥抱开源的价值观进行学习交流","keywords":"蘑菇博客,蘑菇社区,蘑菇技术社区,,蘑菇IT社区,IT社区,技术社区,Java技术分享,Spring教程,开发者社区","webSite":"https://www.moguit.cn/"}}


//////////////////
// WEBPACK FOOTER
// ./conf.json
// module id = wrCz
// module chunks = 40